import type { RefObject } from 'react'
import { gsap, ScrollTrigger, useGSAP, registerMotion, REDUCED, NO_PREF } from './gsap'

/**
 * Every `[data-reveal]` in the page fades up as it enters the viewport, in
 * batches (elements entering together share one staggered tween), once.
 *
 * The hidden start state is CSS (`html.js … { visibility: hidden }`, vc2.css)
 * so nothing flashes before hydration; `autoAlpha` lifts it. Reduced motion:
 * everything is shown at once (the CSS already does; the set makes it explicit).
 */
export function useReveal(scope: RefObject<HTMLElement | null>) {
  useGSAP(
    () => {
      registerMotion()
      if (!scope.current?.querySelector('[data-reveal]')) return
      const mm = gsap.matchMedia()
      mm.add(REDUCED, () => {
        gsap.set('[data-reveal]', { autoAlpha: 1 })
      })
      mm.add(NO_PREF, () => {
        gsap.set('[data-reveal]', { opacity: 0, y: 24 })
        ScrollTrigger.batch('[data-reveal]', {
          start: 'top 88%',
          once: true,
          onEnter: (els) =>
            gsap.to(els, { autoAlpha: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.08, overwrite: true }),
        })
      })
    },
    { scope },
  )
}
